export const formatCurrency = (value) => {
    const numValue = Number(value);
    if (isNaN(numValue)) {
        return 'Invalid value';
    }
    return numValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};